import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './global.less' // global style
import './permission' // permission control
import Antd from 'ant-design-vue';
import Absui from "@ambition.cn/abs-vue2-ui"
import 'ant-design-vue/dist/antd.css';
import VueCropper from 'vue-cropper'
import { mixinValidator, commonMixin } from '@/utils/mixin'
import * as echarts from 'echarts'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(Absui)
Vue.use(VueCropper)
Vue.mixin({ ...mixinValidator, ...commonMixin })
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
